// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_93444fe79c--tooltip--M1G81","arrow_tooltip":"_93444fe79c--arrow_tooltip--xm3aH","arrow":"_93444fe79c--arrow--QDoVo"};